import styled from '@emotion/styled';

import ImageRace from '@/assets/images/guide/img_about_keirin.svg';
import ImageMulti from '@/assets/images/guide/img_about_kuji.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TypeWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(2, 1fr)'],
    gridGap: ['0', '0', '50px', '50px'],
    marginTop: defaultTheme.spacing.xxl,
  }),
);

const TypeBox = styled.div(() =>
  mq({
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'auto 120px',
    paddingTop: '136px',
  }),
);

export const TypeRace = styled(TypeBox)(() =>
  mq({
    backgroundImage: `url(${ImageRace})`,
    borderBottom: [
      `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      'unset',
      'unset',
    ],
    paddingBottom: [
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
      'unset',
      'unset',
    ],
    marginBottom: [
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
      'unset',
      'unset',
    ],
  }),
);

export const TypeMulti = styled(TypeBox)(() =>
  mq({
    backgroundImage: `url(${ImageMulti})`,
  }),
);

export const Point = styled.div(() =>
  mq({
    ':not(:last-of-type)': {
      borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      paddingBottom: defaultTheme.spacing.xxl,
      marginBottom: defaultTheme.spacing.xxl,
    },
  }),
);
